module.exports = __webpack_public_path__ + "static/media/sort-arrow-down-default.191c4445.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Kendra/images/sort-arrow-down-default.svg
// module id = 3239
// module chunks = 0